/* -------------------------------------------------------------------------- */
/*                                 Glightbox                                */
/* -------------------------------------------------------------------------- */

const glightboxInit = () => {
  if (window.GLightbox) {
    window.glightbox = window.GLightbox({
      selector: '[data-gallery]',
    });
  }
};
export default glightboxInit;
